import { render, staticRenderFns } from "./complaintUpload.vue?vue&type=template&id=016baf20&"
import script from "./complaintUpload.vue?vue&type=script&lang=js&"
export * from "./complaintUpload.vue?vue&type=script&lang=js&"
import style0 from "./complaintUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports